import React, {PropTypes} from 'react';

import SquadListContainer from './SquadListContainer.jsx';
import VirtualEventListContainer from './VirtualEventListContainer.jsx';
import OrderReview from 'shared/OrderReview.jsx';
import JumbotronLink from 'shared/JumbotronLink.jsx';
import CaptainInformationForm from './CaptainInformationForm.jsx';
import CoordinatorInformationForm from './CoordinatorInformationForm.jsx';
import ClearCartConfirmationContainer from './ClearCartConfirmationContainer.jsx';

const ReservationReview = ({
  processing,
  cart,
  total,
  countInCart,
  onClearCartClick,
  onContinueReservingClick,
  onReserveClick
}) => (
  <div>
    <OrderReview
      total={total}
    >
      <SquadListContainer />
      <VirtualEventListContainer />
      {!cart || (!cart.squads.length && !cart.virtualEvents.length)
        ? <JumbotronLink
            message={'Go to the scheduler to reserve squads for a captain.'}
            linkPath={`admin/squads`}
            linkText={'Reserve a Squad'}
          />
        : null
      }
    </OrderReview>

    <CaptainInformationForm />

    <CoordinatorInformationForm />

    <ClearCartConfirmationContainer />

    <div className="text-right">
      <button
          type="button"
          className="btn btn-link"
          disabled={processing}
          onClick={onClearCartClick}
        >{'Clear My Cart'}</button>
      {' '}
      {
        total > 0 || countInCart > 0
        ? <span>
            <button
              type="button"
              className="btn btn-link"
              disabled={processing}
              onClick={onContinueReservingClick}
            >{'Return to Calendar'}</button>
            <button
              type="button"
              className="btn btn-primary btn-lg"
              disabled={processing}
              onClick={onReserveClick}
            >{'Reserve Now'}</button>
          </span>
       : null
      }
    </div>
  </div>
);

ReservationReview.propTypes = {
  processing: PropTypes.bool,
  cart: PropTypes.object,
  total: PropTypes.number,
  countInCart: PropTypes.number,
  onClearCartClick: PropTypes.func,
  onContinueReservingClick: PropTypes.func,
  onReserveClick: PropTypes.func
};

ReservationReview.defaultProps = {
  total: 0,
  countInCart: 0
};

export default ReservationReview;



// WEBPACK FOOTER //
// ./src/features/admin/review/ReservationReview.jsx